module.exports = __webpack_public_path__ + "static/media/sendIconforBottomBar.12b8043c.svg";